/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './Phone.css';
import { trackPhoneButtonClick } from './tracking';
import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';
import { hideLastDigits, parsePhoneNumber } from '../../utils/strings';

enum EPhoneState {
  Button = 'button',
  Text = 'text',
}

export interface IPhoneProps {
  page: IPageState;
  total: number;
  phone?: string | null;
  entityId: number;
  favoriteEntities: IFavoriteEntity[];
  isBooked: boolean;
}

export interface IPhoneState {
  type: EPhoneState;
  text: string;
  phone: string;
}

const HOVER_TEXT = 'Показать телефон';
const COUNT_HIDE_SYMBOL = 2;

export class Phone extends React.Component<IPhoneProps, IPhoneState> {
  public constructor(props: IPhoneProps) {
    super(props);

    const phone = props.phone ? parsePhoneNumber(props.phone) : '';

    this.state = {
      type: EPhoneState.Button,
      text: hideLastDigits(phone, COUNT_HIDE_SYMBOL),
      phone,
    };
  }

  public render() {
    const { type, text, phone } = this.state;

    if (!phone) {
      return null;
    }

    const phoneText = (
      <span className={styles['phone']} data-testid="Phone">
        {phone}
      </span>
    );

    return (
      <>
        <div className={styles['container']}>
          {type === EPhoneState.Text ? (
            phoneText
          ) : (
            <span>
              <Button
                size="XS"
                beforeIcon={
                  this.props.isBooked ? undefined : <IconCommunicationPhone16 color="icon-inverted-default" />
                }
                fullWidth={true}
                onClick={this.handleClick}
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseOut}
              >
                {this.props.isBooked ? 'Уточнить у застройщика' : text}
              </Button>
            </span>
          )}
        </div>
        <div {...mergeStyles(styles['container'], styles['print-mode'])}>{phoneText}</div>
      </>
    );
  }

  private handleMouseOver = () => this.setState({ text: HOVER_TEXT });

  private handleMouseOut = () => {
    const { phone } = this.props;

    this.setState({ text: hideLastDigits(parsePhoneNumber(phone!), COUNT_HIDE_SYMBOL) });
  };

  private handleClick = () => {
    const { page, total, favoriteEntities, entityId } = this.props;

    this.setState({ type: EPhoneState.Text });

    const index = favoriteEntities.findIndex(entity => entity.entityId === entityId);
    trackPhoneButtonClick({ entity: favoriteEntities[index], position: index + 1, total, deviceType: page.deviceType });
  };
}
